import * as React from 'react';
import { isNil } from 'lodash';

import MoreButton from 'components/buttons/more-button/MoreButton';
import { withContextMenu } from 'components/context-menu/ContextMenuHOC';

import { __t, applyTranslations } from 'utils/language';

import './mention-card-context-menu.scss';

import type { SyntheticEvent } from 'react';

applyTranslations(require('./mention-card-context-menu.i18n.json'));

type Props = {
  influencerId: number | undefined | null
};

const ContextMenu = withContextMenu(MoreButton, {
  position: 'bottom',
  forceEventPropagation: true
});

class MentionCardContextMenu extends React.PureComponent<Props> {
  getContextMenuItems(): Array<any> | undefined | null {
    const { influencerId } = this.props;

    if (isNil(influencerId)) {
      return null;
    }

    const url = `/content-creator/profiles/${influencerId}`;

    return [
      {
        name: 'add-to-shortlist',
        text: __t('mention_card_context_menu.add_to_shortlist'),
        link: `${url}?openShortlist=true`,
        openInNewTab: true
      },
      {
        name: 'add-to-collection',
        text: __t('mention_card_context_menu.add_to_collection'),
        link: `${url}?openCollections=true`,
        openInNewTab: true
      }
    ];
  }

  handleResidualClick = (event: SyntheticEvent<HTMLElement>): void => {
    event.stopPropagation();
  };

  render(): React.ReactNode {
    return (
      <div
        className="mention-card-context-menu"
        data-qa="mention-card-context-menu"
        onClick={this.handleResidualClick}
      >
        <ContextMenu
          contextMenuProps={{
            items: this.getContextMenuItems()
          }}
          width={20}
          iconHeight={16}
        />
      </div>
    );
  }
}

export default MentionCardContextMenu;
